import { render } from "./ModalAffiliates.vue?vue&type=template&id=1bb591a8&scoped=true"
import script from "./ModalAffiliates.vue?vue&type=script&lang=js"
export * from "./ModalAffiliates.vue?vue&type=script&lang=js"

import "./ModalAffiliates.vue?vue&type=style&index=0&id=1bb591a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb591a8"]])

export default __exports__